import { render, staticRenderFns } from "./SfBadge.vue?vue&type=template&id=d8f0a870&functional=true&"
import script from "./SfBadge.vue?vue&type=script&lang=js&"
export * from "./SfBadge.vue?vue&type=script&lang=js&"
import style0 from "./SfBadge.vue?vue&type=style&index=0&id=d8f0a870&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports